<app-navbar />
<main class="container py-3">
  <h1 class="mb-4">Products</h1>

  <!-- Search bar -->
  <section class="mb-4">
    <div class="input-group input-group-lg shadow-sm">

      <span class="input-group-text bg-white border-end-0">
        <i class="bi bi-search"></i>
      </span>

      <input
        [formControl]="search"
        type="text"
        class="form-control border-start-0"
        placeholder="Search products..."
        (keydown)="write($event)"
      />

      <button class="btn btn-primary">
        Search
      </button>

    </div>
  </section>

  <app-category-carousel class="mb-4"/>

  <body class="row g-3">
    @for (product of paginationInf.items; track product.id) {
      <app-product-card [product]="product" class="col-12 col-sm-6 col-lg-4"/>
    }
  </body>



  <section class="d-flex justify-content-center mt-4">

    <ngb-pagination
      [collectionSize]="paginationInf.totalCount"
      [(page)]="paginationInf.page"
      [pageSize]="paginationInf.query.pageSize"
      [maxSize]="5"
      [boundaryLinks]="false"
      (pageChange)="onPageChange($event)">
    </ngb-pagination>

  </section>


</main>

